// Bidi-isolate wrapper for Latin / numeric runs embedded inside RTL Hebrew text.
// Without isolation, neutrals like ".", "·", "+", "-" attach to the wrong run and
// the punctuation visually jumps to the wrong side. `unicode-bidi: isolate`
// makes the wrapped span a self-contained bidi paragraph, so the surrounding
// Hebrew text is unaffected by what's inside.
export default function LTR({ children, style, ...rest }) {
  return (
    <span
      dir="ltr"
      style={{ unicodeBidi: "isolate", ...style }}
      {...rest}
    >
      {children}
    </span>
  );
}
